import { Navigation, Phone, Globe, BookOpen, CalendarCheck, Ticket } from "lucide-react";

const ACTIONS = [
  { key: "directions", label: "Directions", icon: Navigation, build: (p) =>
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(p.address || `${p.lat},${p.lng}`)}` },
  { key: "call", label: "Call", icon: Phone, build: (p) => (p.phone ? `tel:${p.phone}` : null) },
  { key: "website", label: "Website", icon: Globe, build: (p) => p.website },
  { key: "menu", label: "Menu", icon: BookOpen, build: (p) => p.menu_url },
  { key: "reserve", label: "Reserve", icon: CalendarCheck, build: (p) => p.reservation_url },
  { key: "tickets", label: "Tickets", icon: Ticket, build: (p) => p.ticket_url },
];

export function ActionBar({ place }) {
  const available = ACTIONS.map((a) => ({ ...a, href: a.build(place) })).filter((a) => a.href);
  return (
    <div className="no-scrollbar flex gap-2 overflow-x-auto pb-1" data-testid="action-bar">
      {available.map((a) => {
        const Icon = a.icon;
        const primary = a.key === "directions";
        return (
          <a
            key={a.key}
            href={a.href}
            target={a.key === "call" ? undefined : "_blank"}
            rel="noopener noreferrer"
            data-testid={`action-btn-${a.key}`}
            className={`flex flex-shrink-0 items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-transform hover:scale-105 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${
              primary
                ? "bg-primary text-primary-foreground shadow-md"
                : "border border-border bg-card text-foreground hover:border-primary"
            }`}
          >
            <Icon size={17} /> {a.label}
          </a>
        );
      })}
    </div>
  );
}
